import {
  JobCategoriesBuilder,
  JobCategoryOutput,
} from '../job-categories.types';

export const getAllJobCategories = (builder: JobCategoriesBuilder) =>
  builder.query<JobCategoryOutput[], void>({
    query: () => ({ url: '/job-categories', method: 'GET' }),
  });
